module.exports = __webpack_public_path__ + "static/media/omi_logo.e9cc84c1.svg";